import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { VoucherGeneratorLayoutComponent } from './layout.component';
import { VgSidebarComponent } from './components/sidebar/sidebar.component';
import { VgHeaderComponent } from './components/header/header.component';
import { VgFooterComponent } from './components/footer/footer.component';

@NgModule({
    declarations: [
        VoucherGeneratorLayoutComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        VgSidebarComponent,
        VgHeaderComponent,
        VgFooterComponent
    ],
    exports: [
        VoucherGeneratorLayoutComponent
    ]
})
export class VoucherGeneratorLayoutModule
{
}
